import Output from "./Output";

export const EstimateOutputs = () => {
    return (
        <Output />
    )
}

export default EstimateOutputs;
